var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicityPainting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75763 2.79742C8.30531 2.35773 9.09174 2.3896 9.60529 2.89215L10.1561 3.45074C10.7624 4.08864 11.5098 4.95147 12.1678 5.93414C13.0374 7.23288 13.7946 8.80551 13.7947 10.3785C13.7947 13.0607 11.4411 15.1644 8.62872 15.1646C5.81619 15.1646 3.46173 13.0608 3.46173 10.3785C3.46187 8.80551 4.21909 7.23288 5.08868 5.93414C5.96588 4.62412 7.00217 3.5273 7.65118 2.89215L7.75763 2.79742Z",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6284 12.6646C8.27821 12.6646 7.93144 12.5957 7.60791 12.4616C7.28437 12.3276 6.9904 12.1312 6.74278 11.8836C6.49516 11.636 6.29873 11.342 6.16472 11.0185C6.03071 10.6949 5.96173 10.3482 5.96173 9.99797",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicityPainting);
export default __webpack_public_path__ + "static/media/technicity-painting.1e7caf318df1d5474426e6c7386b2001.svg";
export { ForwardRef as ReactComponent };